var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup405(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 48.276,
    viewBox: "0 0 50 48.276",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0H50V48.276H0z",
    transform: "translate(-46 -317) translate(46 317)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#506f4a",
    d: "M97.564 34.252L95.45 11.041a1.238 1.238 0 0 0-1.234-1.128H90.5V7.435a7.391 7.391 0 0 0-2.174-5.262 7.441 7.441 0 0 0-12.7 5.262v2.479H71.91a1.238 1.238 0 0 0-1.234 1.128l-2.11 23.208a4.956 4.956 0 0 0 4.934 5.405h19.125a4.96 4.96 0 0 0 4.94-5.4zM88.02 9.914h-9.914V7.435a4.957 4.957 0 1 1 9.914 0z",
    transform: "translate(-46 -317) translate(56.345 322.172) translate(-68.546)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup405);
export default __webpack_public_path__ + "static/media/Group 405.42160cd742441ae24c865ff00ed2244a.svg";
export { ForwardRef as ReactComponent };